import config from "../config.json";
import { SettingLocalConfigData } from "../types";
export const DEV = process.env.NODE_ENV === "development";
export const appName = "Group Fire";
export const localConfig: SettingLocalConfigData = config;
